import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
     
        
          <Weather defaultCity="Tokyo"/>
        
     
    </div>
  );
}

export default App;
